import React from "react";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";
import theme from "app/Theme/Theme";

const PaperPlaneIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => {
  return (
    <Svg
      width={width}
      height={height}
      preserveAspectRatio="xMidYMin meet"
      viewBox="0 0 24 24"
      {...props}
    >
      <Path
        d="M21 4.00008C20.9895 3.90822 20.9694 3.81771 20.94 3.73008V3.64008C20.892 3.52879 20.8242 3.42714 20.74 3.34008C20.6551 3.26035 20.557 3.19605 20.45 3.15008H20.36C20.2678 3.07969 20.1623 3.02867 20.05 3.00008H20C19.9005 2.985 19.7994 2.985 19.7 3.00008L1.69996 9.00008C1.49989 9.06584 1.32569 9.19309 1.20219 9.36367C1.07869 9.53426 1.01221 9.73949 1.01221 9.95008C1.01221 10.1607 1.07869 10.3659 1.20219 10.5365C1.32569 10.7071 1.49989 10.8343 1.69996 10.9001L10.23 13.7401L13.07 22.2701C13.1357 22.4702 13.263 22.6444 13.4335 22.7678C13.6041 22.8913 13.8094 22.9578 14.02 22.9578C14.2306 22.9578 14.4358 22.8913 14.6064 22.7678C14.777 22.6444 14.9042 22.4702 14.97 22.2701L20.97 4.27008C20.9922 4.18187 21.0023 4.09103 21 4.00008ZM16.3 6.29008L10.73 11.8601L5.15996 10.0001L16.3 6.29008ZM14 18.8401L12.14 13.2701L17.71 7.70008L14 18.8401Z"
        fill={color}
      />
    </Svg>
  );
};

export default PaperPlaneIcon;
